import { clsx } from "clsx";

interface MarqueeProps {
  className?: string;
  reverse?: boolean;
  pauseOnHover?: boolean;
  children?: React.ReactNode;
  vertical?: boolean;
  repeat?: number;
  // Hold the animation at its start (e.g. until hydration, so copies that
  // mount later start in step with the server-rendered one).
  paused?: boolean;
  [key: string]: any;
}

export default function Marquee({
  className,
  reverse,
  pauseOnHover = false,
  children,
  vertical = false,
  repeat = 4,
  paused = false,
  ...props
}: MarqueeProps) {
  return (
    <div
      {...props}
      className={clsx(
        "group flex overflow-hidden p-2 [--duration:40s] [--gap:1rem] [gap:var(--gap)]",
        {
          "flex-row": !vertical,
          "flex-col": vertical,
        },
        className
      )}
    >
      {Array(repeat)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            // Copies after the first exist only for the seamless loop —
            // hide them from assistive tech so the content is read once.
            className={clsx("flex shrink-0 justify-around [gap:var(--gap)]", {
              "animate-marquee flex-row": !vertical,
              "animate-marquee-vertical flex-col": vertical,
              "group-hover:[animation-play-state:paused]": pauseOnHover,
              "[animation-direction:reverse]": reverse,
            })}
            aria-hidden={i > 0 || undefined}
            // Inline, so it beats the `animation` shorthand in .animate-marquee.
            style={paused ? { animationPlayState: "paused" } : undefined}
          >
            {children}
          </div>
        ))}
    </div>
  );
}
